import type { TaxedMoneyFragment } from '@/graphql/saleor/api';

import type { Maybe } from './types';

export const sumPrices = (
  firstPrice?: Maybe<TaxedMoneyFragment>,
  secondPrice?: Maybe<TaxedMoneyFragment>,
) => {
  if (!firstPrice || !secondPrice) {
    return null;
  }

  return {
    ...firstPrice,
    gross: {
      ...firstPrice.gross,
      amount: firstPrice.gross.amount + secondPrice.gross.amount,
    },
    net: {
      ...firstPrice.net,
      amount: firstPrice.net.amount + secondPrice.net.amount,
    },
    tax: {
      ...firstPrice.tax,
      amount: firstPrice.tax.amount + secondPrice.tax.amount,
    },
  };
};
